<template lang='pug'>
  div
    v-tooltip(right)
      template(v-slot:activator='{on}')
        v-btn(v-on='on' @click='showDialog = !showDialog' text icon color='primary')
          v-icon add
      span Add Load Test
    v-dialog(v-model='showDialog' max-width='500px')
      v-form(v-if='showDialog'
        ref='createForm'
        v-model='createFormValid'
        @submit.prevent='create')
        v-card
          v-card-title
            span.text-h5.primary--text.text--lighten-2 Create Load Test
          v-card-text
            v-container(grid-list-md)
              v-text-field(label='Name' v-model='name' required autofocus :rules='required')
              v-textarea(outlined auto-grow label='Description' v-model='description' @keypress.ctrl.enter='create')
              v-text-field(label='Base URL' v-model='baseUrl' required :rules='required')
          v-card-actions
            v-spacer
            v-btn(text @click.native='showDialog=false') Cancel
            v-btn(text color='primary' type='submit') Create
</template>

<script>
import {get} from 'lodash';
import {mapGetters} from 'vuex';
import Notifications from '../services/notification.service';
import LoadTest from '../api/loadTest';

export default {
  name: 'BionicMetricsCreateLoadTest',
  computed: {
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount'
    })
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    async create() {
      if (!this.createFormValid) {
        this.$refs.createForm.validate();
        return;
      }
      try {
        const loadTest = await LoadTest.create({
          name: this.name,
          description: this.description,
          baseUrl: this.baseUrl
        });
        this.name = null;
        this.description = null;
        this.showDialog = false;
        await this.$router.push(`/load-test/${loadTest.guid}`);
      } catch (error) {
        console.error(`Error creating load test: ${error.message}`);
        console.error(get(error, 'response.data.message'));
        Notifications.alert('There was a problem creating the load test');
      }
    }
  },
  data() {
    return {
      createFormValid: null,
      showDialog: false,
      name: null,
      description: null,
      baseUrl: null,
      required: [(v) => !!v || 'Required field']
    };
  }
};
</script>

<style scoped>

</style>
